export const UPLOAD_LIMIT = 1
export const ALLOWED_PASSPORT_FILE_TYPES = ['.jpg', '.pdf', '.png', '.jpeg']
export const ALLOWED_STATUS_FILE_TYPES = ['.jpg', '.pdf', '.png', '.jpeg']
